module.exports = __webpack_public_path__ + "741d79972495d3bb4e9dfbd5fef0fbf1.MP3";